module.exports = __webpack_public_path__ + "img/engine-status-red.dbccad99.svg";